import React from "react";
import SwitchWithIcon from "components/common/SwitchWithIcon";
import { BiMinus } from "react-icons/bi";
import { BsPlusLg } from "react-icons/bs";
import { applyParticipantTerminology } from "Constants/constant";
import useCareLabels from "hooks/useCareLabels";
import {
  isAiPermissionsParent,
  isShippedAiPermission,
} from "config/aiRolePermissions";

const ComingSoonPill = () => (
  <span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-500">
    Coming soon
  </span>
);

const PermissionItems = (props) => {
  const { index, handleRowClick, expandedRows, item, handleSwitchChange } =
    props;
  const { careSector } = useCareLabels();
  const formatDescription = (description) =>
    applyParticipantTerminology(description, careSector);

  const isAiParent = isAiPermissionsParent(item);

  return (
    <React.Fragment key={index}>
      <tr className="even:bg-white odd:bg-gray-50">
        <td
          className="whitespace-nowrap  py-4 px-3  text-sm sm:pl-3 w-[40%] "
          onClick={() => item.children.length > 0 && handleRowClick(item.id)}
        >
          <div className="flex align-center cursor-pointer ">
            {item.children.length > 0 ? (
              expandedRows.includes(item.id) ? (
                <BiMinus className="mt-1 text-gray-600" />
              ) : (
                <BsPlusLg className="h-3 w-3 mt-1 text-gray-600" />
              )
            ) : (
              <></>
            )}
            <span className="ml-3"> {formatDescription(item.description)}</span>
          </div>
        </td>
        <td className="text-center border">
          <SwitchWithIcon
            onChange={(value) => handleSwitchChange(item.id, value)}
            checked={item.isChecked}
          />
        </td>
      </tr>
      {expandedRows.includes(item.id) &&
        item?.children?.map((el, childIndex) => {
          const isAiChild = isAiParent;
          const shipped = !isAiChild || isShippedAiPermission(el.name);

          return (
            <tr
              className={`even:bg-white odd:bg-gray-50 ${!shipped ? "opacity-75" : ""}`}
              key={childIndex}
            >
              <td className="whitespace-nowrap  border py-4 px-3 text-sm sm:pl-3 w-[40%]">
                <div className="flex align-center min-w-0">
                  <span className="ml-9">{formatDescription(el.description)}</span>
                </div>
              </td>
              <td className="text-center border">
                <div className="flex items-center justify-center gap-3">
                  {!shipped && <ComingSoonPill />}
                  <SwitchWithIcon
                    checked={Boolean(el.isChecked)}
                    isSmall={true}
                    disabled={!shipped}
                    onChange={(value) =>
                      shipped && handleSwitchChange(item.id, value, el.id)
                    }
                  />
                </div>
              </td>
            </tr>
          );
        })}
    </React.Fragment>
  );
};

export default PermissionItems;
